<template>
  <b-row>
    <b-col cols="12">
      <b-table-simple responsive bordered striped class="w-100">
        <b-thead>
          <b-tr>
            <b-th v-for="(col, index) in tableColumns" :key="index">
              {{ col.label }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-if="tableItems && tableItems.length > 0">
            <template v-for="(row, rowIndex) in tableItems">
              <b-tr
                :key="rowIndex * tableColumns.length + 1"
                :class="rowClass(row)"
              >
                <td
                  v-for="(col, colIndex) in tableColumns"
                  :key="colIndex + rowIndex * rowIndex + 1"
                  :class="cellClass(col)"
                >
                  <template v-if="!$scopedSlots[col.key]">
                    {{
                      col.formatter
                        ? col.formatter(row[col.key], col.label, row)
                        : row[col.key]
                    }}
                  </template>
                  <template v-else>
                    <slot :name="col.key" :index="rowIndex" :item="row"></slot>
                  </template>
                </td>
              </b-tr>

              <!-- Row details accordion -->
              <template v-if="$scopedSlots['cellDetails']">
                <b-tr ref="detailsRow" :index="rowIndex" class="d-none">
                  <td :colspan="cellDetailsColSpan">
                    <slot
                      name="cellDetails"
                      :index="rowIndex"
                      :item="row"
                    ></slot>
                  </td>
                </b-tr>
              </template>
            </template>
          </template>
          <template v-else>
            <b-tr>
              <td :colspan="tableColumns.length" class="text-center py-1">هیچ موردی یافت نشد!</td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </b-col>
    <b-col cols="12">
      <custom-pagination
        v-if="totalCount"
        @changePage="changePage"
        :pageNumber="pageNumber"
        :count="count"
        :totalCount="totalCount"
      ></custom-pagination>
    </b-col>
  </b-row>
</template>

<script>
export default {
  emits: ["changePage"],
  props: {
    pageNumber: {
      type: [String, Number],
      required: false,
    },
    count: {
      type: [String, Number],
      required: false,
    },
    totalCount: {
      type: [String, Number],
      required: false,
    },
    tableItems: {
      type: Array,
      required: false,
    },
    tableColumns: {
      type: Array,
      required: true,
    },
    cellDetailsColSpan: {
      type: Number,
      default: 4,
    },
    rowClass: {
      type: Function,
      default: (rowDetails) => "",
    },
    cellClass: {
      type: Function,
      default: (colDetails) => "",
    },
  },
  methods: {
    showRowDetails(rowIndex) {
      let findedItem = this.$refs.detailsRow.find((item) => {
        return item.$attrs.index == rowIndex;
      });
      if (findedItem) {
        findedItem.$el.classList.toggle("d-none");
      }
    },
    changePage(pageNumber) {
      this.$emit("changePage", pageNumber);
    },
  },
  components: {
    BTableSimple,
    BTr,
    BTh,
    BThead,
    BTable,
    BTbody,
    BTfoot,
    BButton,
    BLink,
    BRow,
    BCol,
    CustomPagination,
  },
};
import {
  BTable,
  BButton,
  BLink,
  BRow,
  BCol,
  BTableSimple,
  BThead,
  BTr,
  BTh,
  BTbody,
  BTfoot,
} from "bootstrap-vue";
import CustomPagination from "@/views/components/Utils/CustomPagination.vue";
</script>
<style>
.accordion-transition-enter-active {
  animation: acc-slide-down 0.5s ease-out;
  overflow: hidden;
}
.accordion-transition-leave-active {
  animation: acc-slide-up 0.5s ease-out;
  overflow: hidden;
}
@keyframes acc-slide-down {
  0% {
    display: hidden;
  }
  100% {
    display: block;
  }
}
@keyframes acc-slide-up {
  0% {
    display: block;
  }
  100% {
    display: hidden;
  }
}
</style>
